"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._getDashboardContractorCoalPerformance = void 0;
const axios_1 = __importDefault(require("axios"));
const error_response_1 = require("utils/error-response");
const get_from_localstorage_1 = require("utils/get-from-localstorage");
const defaultItem = {
    non_sm: [],
    sm: [],
    total: {
        id: '',
        area: '',
        a_plan: 100,
        trip: '',
        actual: 100,
        precentage_a_plan: 0,
        contractor_name: ''
    },
    non_sm_total: {
        id: '',
        area: '',
        a_plan: 100,
        trip: '',
        actual: 100,
        precentage_a_plan: 0,
        contractor_name: ''
    },
    sm_total: {
        id: '',
        area: '',
        a_plan: 100,
        trip: '',
        actual: 100,
        precentage_a_plan: 0,
        contractor_name: ''
    }
};
const _getDashboardContractorCoalPerformance = (params) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const url = String(process.env.API_ENDPOINT) + '/transaction/dashboard/stockpile';
        const config = {
            params: params,
            headers: {
                'X-User-Token': get_from_localstorage_1.getFromLocalStorage.token(),
            }
        };
        const response = yield axios_1.default.get(url, config);
        return response.data;
    }
    catch (e) {
        const { errorCode, errorMessage, isError } = (0, error_response_1.errorResponse)(e);
        return {
            isError,
            errorCode,
            errorMessage,
            dataToday: defaultItem,
            dataMtd: defaultItem,
            dataYtd: defaultItem,
            data: [],
        };
    }
});
exports._getDashboardContractorCoalPerformance = _getDashboardContractorCoalPerformance;
